import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import Translator from "../../Translation/Translator";

export default function* chargeCredit(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CHARGE_CREATE_CREDIT_REQUEST
    });

    yield call(Http.post, `charges/${action.payload?.charge?.id}/credit`, {
      amount: action.payload?.amount,
      description: action.payload?.description,
      invoiceDate: action.payload?.invoiceDate,
      invoiceNumber: action.payload?.invoiceNumber
    });

    yield put({
      type: Constants.GLOBAL_CHARGE_CREATE_CREDIT_SUCCESS
    });

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-charge-credited-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CHARGE_CREATE_CREDIT_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchChargeCredit() {
  yield takeEvery(Constants.GLOBAL_CHARGE_CREATE_CREDIT_START, chargeCredit);
}
